/** @file What the export dialog can pick from a document: animation base names, skins, set directions. */
import { names } from '@pose2d/format/names';
import type { DirectionsDoc, Doc } from '@pose2d/format/types';

/** Pick lists; mirrorFix fix animations travel with their base and are not listed (§5.4). */
export interface ExportChoices {
  animations: string[];
  skins: string[];
  directions: string[];
}

const byName = (a: string, b: string): number => a.localeCompare(b, 'en');

/** Directions come in compass order (names.DIRS). */
export function exportChoices(doc: Doc): ExportChoices {
  const entries: DirectionsDoc['entries'] = doc.directions?.entries ?? {};
  const fixIds = new Set(names.DIRS.flatMap((d) => Object.values(entries[d]?.fix?.animations ?? {})));
  const bases = Object.entries(doc.animations).filter(([id]) => !fixIds.has(id)).map(([, a]) => names.splitAnimation(a.name).base);
  return {
    animations: [...new Set(bases)].sort(byName),
    skins: Object.values(doc.skins).map((s) => s.name).sort(byName),
    directions: names.DIRS.filter((d) => entries[d] !== undefined),
  };
}
